import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Text } from '@/lib/v2/components';

import { atomRuleData } from '@/modules/RulesModule/atoms/rules';
import { TRANSLATE_RULES_PRESENCE_OPTIONS } from '@/modules/RulesModule/constants';
import { RulesOptions } from '@/modules/RulesModule/interfaces';

const NodeContentDate = () => {
  const { t } = useTranslation('rules');
  const rulesData: RulesOptions = useAtomValue(atomRuleData);

  const presenceText = useMemo(() => {
    return rulesData?.selectedGroupOrSegment?.value === 'user'
      ? t(`${TRANSLATE_RULES_PRESENCE_OPTIONS}.group`)
      : t(`${TRANSLATE_RULES_PRESENCE_OPTIONS}.segment`);
  }, [rulesData, t]);

  const formattedText = useMemo(() => {
    const text = `${rulesData?.presenceCondition?.name || ''} : ${
      rulesData?.selectedGroupOrSegment?.name?.toString() || ''
    }`;
    return text;
  }, [rulesData]);

  return (
    <>
      <Text fontWeight="medium" variant="text">
        {presenceText}
      </Text>
      <Text truncate fontWeight="medium" variant="text-sm">
        {formattedText}
      </Text>
    </>
  );
};

export default NodeContentDate;
